module.exports = __webpack_public_path__ + "static/media/offset-bc-icon-177x197.01d14b2b.jpg";